import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { SHIFT_DISCOVERY_WORKPLACE_LEAVE_REVIEW_MODAL_PATH } from "../../ShiftDiscovery/paths";
import { useWorkplaceModalsDataContext } from "../../ShiftDiscovery/useWorkplaceModalsDataContext";
import { useCanLeaveReview } from "./useCanLeaveReview";

interface WorkplaceReviewsFooterProps {
  workplaceId: string;
  workplaceType?: string;
}

export function WorkplaceReviewsFooter(props: WorkplaceReviewsFooterProps) {
  const { workplaceId, workplaceType } = props;

  const { canLeaveReview } = useCanLeaveReview({ workplaceId, workplaceType });
  const { generateModalPath } = useWorkplaceModalsDataContext();

  if (!canLeaveReview) {
    return null;
  }

  return (
    <DialogFooter withShadow orientation="horizontal">
      <Button
        fullWidth
        variant="outlined"
        size="large"
        href={generateModalPath(SHIFT_DISCOVERY_WORKPLACE_LEAVE_REVIEW_MODAL_PATH, {
          workplaceId,
        })}
      >
        Leave a Review
      </Button>
    </DialogFooter>
  );
}
